import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getUniqueKey } from '../../common/arrayHelper';
import ThreadSummaryBlock from './ThreadSummaryBlock';
import Simplebar from 'simplebar-react';

import _map from 'lodash/map';

const styles = theme => ({
    root: {
        height: 'calc(100% - 60px)',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
});

const getDefns = params => {
    const { props } = params;
    const { classes } = props;

    const defns = {};

    setClassNameInDefns(defns, classes);

    return defns;
};

const ThreadSummaries = props => {
    const { data, threadSummaryOnClick } = props;
    const { setShowMessageDetails } = props;

    const defns = getDefns({ props });
    return (
        <Simplebar {...defns.root}>
            {_map(data, (threadSummary, idx) => (
                <div key={`conversations${getUniqueKey()}`} onClick={() => setShowMessageDetails(true)}>
                    <ThreadSummaryBlock data={threadSummary} onClick={threadSummaryOnClick} />
                </div>
            ))}
        </Simplebar>
    );
};

export default withStyles(styles)(ThreadSummaries);
